export type TranscriptCompletedMessage = {
  itemId: string;
  transcription: string;
  startTime: number;
};

export type TranscriptEndMessage = {
  transcription: string;
  language: string;
  duration: number;
};

export type SendChunkMessage = {
  data: string;
};

export interface TranscriptionStreamText {
  text: string;
  startTime: number;
}

export enum NoiseReduction {
  FAR_FIELD = "far_field",
  NEAR_FIELD = "near_field",
}

export enum TranscriptionProviderName {
  OPENAI = "openai",
  SPEECHMATIC = "speechmatic",
  DEEPGRAM = "deepgram",
}

export enum TranscriptionNoRealtimeProviderName {
  OPENAI = "openai/gpt-4o-transcribe",
  ELEVENLABS = "elevenlabs/scribe_v1",
  DEEPGRAM_NOVA_3_MEDICAL = "deepgram/nova-3-medical",
  DEEPGRAM_NOVA_3 = "deepgram/nova-3",
  DEEPGRAM_NOVA_2 = "deepgram/nova-2",
}

export const TranscriptionLanguageWhisperAvailable = [
  { value: "auto", label: "Detect automatically" },
  { value: "eng", label: "English" },
  { value: "spa", label: "Spanish" },
  { value: "fra", label: "French" },
  { value: "por", label: "Portuguese" },
  { value: "jap", label: "Japanese" },
  { value: "cmn", label: "Chinese (Mandarin)" },
];
